import { render, staticRenderFns } from "./InTheFieldCard.vue?vue&type=template&id=2b698e60&scoped=true&"
import script from "./InTheFieldCard.vue?vue&type=script&lang=js&"
export * from "./InTheFieldCard.vue?vue&type=script&lang=js&"
import style0 from "./InTheFieldCard.vue?vue&type=style&index=0&id=2b698e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b698e60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VRow})
